import { TEMPLATE } from 'actions/TemplateActions'

export default function templateReducer(state = null, action) {
  switch (action.type) {
    case TEMPLATE:
      return action.payload
    default:
      return state
  }
}
